import React from 'react';
import { ListFieldSection, FieldSet } from 'Components/Layout';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown, IWithWorksheetInjectedProps } from 'Components/Worksheets//Core';
import { Checkbox, Field, RadioGroup, TextOutput } from 'Components/Core';
import { useSelector } from 'react-redux';
import { Guid } from 'Lib/Guid';
import { ConeType } from 'Components/Worksheets/AtterbergLimitWorksheet/types';

let BsEnIsoLiquidLimitEquipmentDetailsSection: React.FC<IWithWorksheetInjectedProps> = ({
  createWorksheetSelector,
}) => {
  const timerId = useSelector(createWorksheetSelector!('Timer.Id')) as Guid;
  const fallconeId = useSelector(createWorksheetSelector!('Fallcone.Id')) as Guid;
  const coneId = useSelector(createWorksheetSelector!('Cone.Id')) as Guid;
  const isConeTypeDetermined = useSelector(createWorksheetSelector!('IsConeTypeDeterminedFromCalibrationValues'));
  const coneType = useSelector(createWorksheetSelector!('ConeType'));

  const coneTypeOptions = [
    { label: '80g/30°', value: ConeType.Type_80_30 },
    { label: '60g/60°', value: ConeType.Type_60_60 },
  ];

  return (
    <ListFieldSection heading="Equipment Details">
      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="fallcone"
        name="Fallcone"
        importedCalibration={{}}
        importModel={{ Id: fallconeId }}
      />
      <FieldSet>
        <Field input={<WorksheetEquipmentDropdown />} equipmentType="cone" name="Cone" importModel={{ Id: coneId }} />

        {isConeTypeDetermined ? (
          <Field
            input={<TextOutput />}
            value={coneTypeOptions.find((i: any) => i && i.value === coneType)?.label}
            name="ConeType"
            emph
          />
        ) : (
          <Field input={<RadioGroup />} name="ConeType" options={coneTypeOptions} emph />
        )}
        <Field input={<Checkbox />} name="IsConeSuitabilityChecked" />
      </FieldSet>

      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="timer"
        name="Timer"
        importedCalibration={{}}
        importModel={{ Id: timerId }}
      />
    </ListFieldSection>
  );
};

BsEnIsoLiquidLimitEquipmentDetailsSection = withInjectedProps(BsEnIsoLiquidLimitEquipmentDetailsSection);

export { BsEnIsoLiquidLimitEquipmentDetailsSection };
export default BsEnIsoLiquidLimitEquipmentDetailsSection;
